import { useQuery } from "@tanstack/react-query";
import { QuotesClient, QuoteStorefrontDto } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";

export default function useGetStorefronts(enabled = true) {
  const api = useApi(QuotesClient);

  return useQuery<QuoteStorefrontDto[]>({
    queryKey: ["quotes", "storefronts"],
    queryFn: () => api.getQuoteStorefronts(),
    enabled,
  });
}
